<template>
  <article class="article-profile">
    <div class="form-container">
      <h3>Votre compte</h3>
      <form @submit.prevent>
        <label for="name">{{ $t('login.createForm.name.label') }}</label>
        <input v-model="name" type="text" :placeholder="userName" id="name" />
        <p class="error" v-if="nameErrorCode">{{ nameErrorText }}</p>
        <button @click="updateName()" class="button">Enregistrer</button>
      </form>
    </div>

    <div class="form-container">
      <h6>Modifier votre mot de passe</h6>
      <form @submit.prevent class="change-password">
        <label for="old-password">Ancien mot de passe</label>
        <input
          v-model="oldPwd"
          type="password"
          placeholder="******"
          id="old-password"
        />
        <label for="new-password">Nouveau mot de passe</label>
        <input
          v-model="newPwd"
          type="password"
          placeholder="******"
          id="new-password"
        />
        <p class="error" v-if="pwdErrorCode">{{ pwdErrorText }}</p>
        <button @click="updatePwd()" class="button">Enregistrer</button>
      </form>
    </div>
  </article>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import userService from '../../services/user.service';

export default {
  data() {
    return {
      name: '',
      oldPwd: '',
      newPwd: '',
      nameErrorCode: null,
      pwdErrorCode: null,
    };
  },
  methods: {
    updateName() {
      this.nameErrorCode = null;
      if (this.name.length < 5) {
        this.nameErrorCode = 'name-too-short';
        return;
      }
      this.$store.dispatch('updateProfile', {
        name: this.name !== '' ? this.name : this.userProfile.name,
      });
      this.$toasted.show('Profil modifié !');
      this.name = '';
    },
    updatePwd() {
      this.pwdErrorCode = '';
      userService
        .updatePassword(this.oldPwd, this.newPwd)
        .then(() => {
          this.oldPwd = '';
          this.newPwd = '';
          this.$toasted.show('Mot de passe modifié !');
        })
        .catch((err) => {
          console.error(err.message);
          this.pwdErrorCode = err.code;
        });
    },
  },
  computed: {
    ...mapState(['userProfile']),
    userName() {
      return _.get(this.userProfile, 'name', '');
    },
    nameErrorText() {
      return this.$t(`login.errors.${this.nameErrorCode}`);
    },
    pwdErrorText() {
      return this.$t(`login.errors.${this.pwdErrorCode}`);
    },
  },
};
</script>

<style lang="scss" scoped src="./Profile.scss"></style>
